interface Props {
  kind: "loading" | "empty" | "error";
  icon: string;
  title: string;
  hint?: string;
}

const accent: Record<Props["kind"], string> = {
  loading: "text-text-muted/30",
  empty: "text-text-muted/30",
  error: "text-signal-error",
};

const titleAccent: Record<Props["kind"], string> = {
  loading: "text-text-muted/60",
  empty: "text-text-muted/60",
  error: "text-signal-error",
};

export function StateMessage({ kind, icon, title, hint }: Props) {
  return (
    <div
      role={kind === "error" ? "alert" : "status"}
      className="flex flex-col items-center gap-2 py-12 px-4 text-center"
    >
      <span
        className={`material-symbols-outlined text-[28px] ${accent[kind]}`}
        aria-hidden="true"
      >
        {icon}
      </span>
      <span className={`font-mono text-12 font-bold uppercase tracking-widerx ${titleAccent[kind]}`}>
        {title}
      </span>
      {hint && (
        <span className="text-11 leading-4 text-text-muted max-w-[320px]">{hint}</span>
      )}
    </div>
  );
}
